export function getFrontAndBackEndsAdds(addOns: number, vsc: number, gap: number): number {
  return addOns + vsc + gap;
}
